import React from 'react'

import { Popover } from 'antd'

import { Button, Input, InputGroup, Loader, Panel, PanelGroup, Radio, RadioGroup } from 'rsuite'

import { Divider, IconButton, Stack } from '@mui/material'
import HighlightOffOutlinedIcon from '@mui/icons-material/HighlightOffOutlined'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined'
import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import DriveFolderUploadOutlinedIcon from '@mui/icons-material/DriveFolderUploadOutlined'

import Icon from '@mdi/react'
import { mdiFilterOutline } from '@mdi/js'

import css from './umkd.module.scss'
import emptyDoc from './../../../img/empty_documents.svg'
import { BootstrapTooltip } from '../../_ui/tooltip'
import Empty from '../../_ui/empty'
import Dropzone from 'react-dropzone'

const Umkd = (props: any) => {
    return (
        <div className={css.main}>
            <div className={css.mainHeader}>
                <div style={{ margin: "auto 0" }}>УМКД - Список направлений подготовки ({props.directionTrainingList.length})</div>

                <InputGroup inside style={{ width: "350px" }} disabled={props.directionTrainingList.length ? false : true}>
                    <InputGroup.Addon>
                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="md" placeholder="Фильтр направлений подготовки..."
                        autoComplete="off" style={{ paddingRight: "40px" }}
                        value={props.valueFilterDirectionTraining}
                        onChange={value => props.setValueFilterDirectionTrainig(value)}
                    />

                    {props.valueFilterDirectionTraining &&
                        <InputGroup.Addon onClick={() => props.clearFilterValues('directionTraining')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    }
                </InputGroup>
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <div className={css.mainBody}>
                <div className={css.tBody}>
                    {!props.directionTrainingList.length
                        ? <Empty image={emptyDoc} description="Данные отсутствуют" />
                        : <PanelGroup accordion activeKey={props.selectedDirectionTrainingID} onSelect={props.onSelectedDirectionTraining}> {
                            props.directionTrainingList.filter((val: any) => {
                                let stringReturn

                                let directionTrainingName = val.direction_training_name.toLowerCase().includes(props.valueFilterDirectionTraining.toLowerCase())

                                if (directionTrainingName) {
                                    stringReturn = val
                                }

                                return stringReturn
                            }).map((directionTraining: any) => {
                                return (
                                    <Panel key={directionTraining.direction_training_id} header={directionTraining.direction_training_name} eventKey={directionTraining.direction_training_id} id={directionTraining.direction_training_id}>
                                        <>
                                            {props.isVisibleLoaderSpecialization
                                                ? <div style={{ height: "100px", position: "relative", background: "#fff" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                                                : <Specializations {...props} />
                                            }
                                        </>
                                    </Panel>
                                )
                            })
                        }</PanelGroup>
                    }
                </div>
            </div>
        </div>
    )
}

// Специализации
const Specializations = (props: any) => {
    return (
        <div className={css.boxData}>
            <div className={css.mainHeader}>
                <div style={{ margin: "auto 0" }}>Список специализаций ({props.specializationList.length})</div>

                <InputGroup inside style={{ width: "350px" }} disabled={props.specializationList.length ? false : true}>
                    <InputGroup.Addon>
                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="md" placeholder="Фильтр специализаций..."
                        autoComplete="off" style={{ paddingRight: "40px" }}
                        value={props.valueFilterSpecialization}
                        onChange={value => props.setValueFilterSpecialization(value)}
                    />

                    {props.valueFilterSpecialization &&
                        <InputGroup.Addon onClick={() => props.clearFilterValues('specialization')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    }
                </InputGroup>
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <PanelGroup accordion activeKey={props.selectedSpecializationID} onSelect={props.onSelectedSpecialization}>
                {!props.specializationList.length
                    ? <Empty image={emptyDoc} description="Данные отсутствуют" />
                    : props.specializationList.filter((val: any) => {
                        let stringReturn

                        let specializationName = val.educational_program_name.toLowerCase().includes(props.valueFilterSpecialization.toLowerCase())

                        if (specializationName) {
                            stringReturn = val
                        }

                        return stringReturn
                    }).map((specialization: any) => {
                        return (
                            <Panel key={specialization.educational_program_id} header={specialization.educational_program_name} eventKey={specialization.educational_program_id} id={specialization.educational_program_id}>
                                <>
                                    {props.isVisibleLoaderSubject
                                        ? <div style={{ height: "100px", position: "relative", background: "#fff" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                                        : <Subjects {...props} />
                                    }
                                </>
                            </Panel>
                        )
                    })
                }
            </PanelGroup>
        </div>
    )
}

// Дисциплины
const Subjects = (props: any) => {
    return (
        <div className={css.boxData}>
            <div className={css.mainHeader}>
                <div style={{ margin: "auto 0" }}>Список дисциплин ({props.subjectsList.length})</div>

                <InputGroup inside style={{ width: "350px" }} disabled={props.subjectsList.length ? false : true}>
                    <InputGroup.Addon>
                        <Icon path={mdiFilterOutline} size={1} style={{ margin: "-4px 0 0 -6px" }} />
                    </InputGroup.Addon>

                    <Input type="text" size="md" placeholder="Фильтр дисциплин..."
                        autoComplete="off" style={{ paddingRight: "40px" }}
                        value={props.valueFilterSubject}
                        onChange={value => props.setValueFilterSubject(value)}
                    />

                    {props.valueFilterSubject &&
                        <InputGroup.Addon onClick={() => props.clearFilterValues('subject')} style={{ margin: "-7px -7px 0 0" }}>
                            <BootstrapTooltip title="Очистить" placement="bottom" arrow>
                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                    <HighlightOffOutlinedIcon sx={{ fontSize: 18 }} />
                                </IconButton>
                            </BootstrapTooltip>
                        </InputGroup.Addon>
                    }
                </InputGroup>
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            <PanelGroup accordion activeKey={props.selectedSubjectID} onSelect={props.onSelectedSubject}>
                {!props.subjectsList.length
                    ? <Empty image={emptyDoc} description="Данные отсутствуют" />
                    : props.subjectsList.filter((val: any) => {
                        let stringReturn

                        let subjectName = val.FullName.toLowerCase().includes(props.valueFilterSubject.toLowerCase())

                        if (subjectName) {
                            stringReturn = val
                        }

                        return stringReturn
                    }).map((subject: any) => {
                        return (
                            <Panel key={subject.id} header={subject.FullName} eventKey={subject.id} id={subject.id}>
                                <>
                                    {props.isVisibleLoaderFiles
                                        ? <div style={{ height: "100px", position: "relative", background: "#fff" }}><Loader center size="md" content="Загрузка данных..." vertical /> </div>
                                        : <Files {...props} />
                                    }
                                </>
                            </Panel>
                        )
                    })
                }
            </PanelGroup>
        </div>
    )
}

// Файлы
const Files = (props: any) => {
    return (
        <div className={css.filesBody}>
            <div className={css.filesHeader}>
                <div style={{ margin: "auto 0" }}>Список файлов</div>

                <div className={props.navFilesActive === 0 ? `${css.btnFileNavActive}` : `${css.btnFileNav}`} onClick={() => { props.setNavFilesActive(0) }}>Не распределённые файлы</div>
                <div className={props.navFilesActive === 1 ? `${css.btnFileNavActive}` : `${css.btnFileNav}`} onClick={() => { props.setNavFilesActive(1) }}>РПД файлы</div>
                <div className={props.navFilesActive === 2 ? `${css.btnFileNavActive}` : `${css.btnFileNav}`} onClick={() => { props.setNavFilesActive(2) }}>МО файлы</div>
            </div>

            <Divider orientation="horizontal" variant="middle" flexItem sx={{ m: "0 0" }} />

            {props.navFilesActive === 0 &&
                <div className={css.filesContent}>
                    <div className={css.fileHead}>
                        <div>Имя файла</div>
                        <div style={{ textAlign: 'center' }}>Дата создания</div>
                        <div></div>
                    </div>

                    <div className={css.fileBody}>
                        {!props.filesListAll.length
                            ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="250px" heightImg="200px" />
                            : props.filesListAll.map((file: any) => {
                                return (
                                    <div key={file.file_id} className={css.fileRow}>
                                        <div style={{ margin: 'auto 0' }}>{file.file_name}</div>
                                        <div style={{ margin: 'auto 0', textAlign: 'center' }}>{file.create_date_time}</div>
                                        <div style={{ margin: "auto 0", display: "flex", gap: "5px" }}>
                                            <a href={file.file_url} target="_blank" rel="noreferrer">
                                                <BootstrapTooltip title={`Открыть файл ${file.file_name}`} placement="top" arrow>
                                                    <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                        <FileDownloadOutlinedIcon />
                                                    </IconButton>
                                                </BootstrapTooltip>
                                            </a>

                                            <Popover placement="bottom" trigger="click"
                                                content={
                                                    <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                        <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600" }}>Удалить этот файл?</div>

                                                        <Button appearance="primary" size="lg"
                                                            onClick={() => props.onClickButtonDeleteFile(file.file_id)}
                                                        >ДА</Button>
                                                    </Stack>
                                                }>

                                                <div>
                                                    <BootstrapTooltip title={`Удалить файл ${file.file_name}`} placement="top" arrow>
                                                        <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                            <DeleteOutlinedIcon />
                                                        </IconButton>
                                                    </BootstrapTooltip>
                                                </div>
                                            </Popover>

                                            <Popover placement="bottom" trigger="click"
                                                content={
                                                    <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                        <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600" }}>Укажите, куда переместить файл?</div>

                                                        <RadioGroup
                                                            value={props.fileMoveType}
                                                            onChange={value => { props.setFileMoveType(value) }}
                                                            style={{ fontSize: '15px', fontWeight: '600', letterSpacing: '1px' }}>

                                                            <Radio value="MO">МО файлы</Radio>
                                                            <Radio value="RPD">РПД файлы</Radio>
                                                        </RadioGroup>

                                                        <Button appearance="primary" size="lg"
                                                            onClick={() => props.onClickButtonMovedFile(file.file_id)}
                                                        >ПЕРЕМЕСТИТЬ</Button>
                                                    </Stack>
                                                }>

                                                <div>
                                                    <BootstrapTooltip title={`Переместить файл ${file.file_name}`} placement="top" arrow>
                                                        <IconButton size="small" sx={{ color: "red", m: "auto 0" }}>
                                                            <DriveFolderUploadOutlinedIcon />
                                                        </IconButton>
                                                    </BootstrapTooltip>
                                                </div>
                                            </Popover>
                                        </div>
                                    </div>
                                )
                            })
                        }
                    </div>

                    <div className={css.fileFooter}>
                        * НЕОБХОДИМО ИЗ РАЗДЕЛА <b>Не распределённые файлы</b>, РАСПРЕДЕЛИТЬ ИХ ПО РАЗДЕЛАМ <b>РПД файлы</b> ИЛИ <b>МО файлы</b>.<br />
                        * В ДАЛЬНЕЙШЕМ РАЗДЕЛ <b>Не распределённые файлы</b>, БУДЕТ УДАЛЁН.
                    </div>
                </div>
            }

            {props.navFilesActive === 1 &&
                <div className={css.filesContent}>
                    <div className={css.fileHead}>
                        <div>Имя файла</div>
                        <div style={{ textAlign: 'center' }}>Дата создания</div>
                        <div></div>
                    </div>

                    <Dropzone onDropAccepted={(files) => props.fileUploader(files, 'RPD')}>
                        {({ getRootProps, isDragAccept, isDragActive }) => (
                            <div {...getRootProps({ className: isDragAccept ? `${css.fileBody} dropZone` : `${css.fileBody}`, onClick: event => event.stopPropagation() })}>
                                {isDragActive
                                    ? <div style={{ margin: "auto 0" }}>Перетащите сюда файлы с расширением <b>".pdf"</b></div>
                                    : !props.filesListRpd.length
                                        ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="250px" heightImg="200px" />
                                        : props.filesListRpd.map((file: any) => {
                                            return (
                                                <div key={file.file_id} className={css.fileRow}>
                                                    <div style={{ margin: 'auto 0' }}>{file.file_name}</div>
                                                    <div style={{ margin: 'auto 0', textAlign: 'center' }}>{file.create_date_time}</div>
                                                    <div style={{ margin: "auto 0", display: "flex", gap: "5px" }}>
                                                        <a href={file.file_url} target="_blank" rel="noreferrer">
                                                            <BootstrapTooltip title={`Открыть файл ${file.file_name}`} placement="top" arrow>
                                                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                                    <FileDownloadOutlinedIcon />
                                                                </IconButton>
                                                            </BootstrapTooltip>
                                                        </a>

                                                        <Popover placement="bottom" trigger="click"
                                                            content={
                                                                <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                                    <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600" }}>Удалить этот файл?</div>

                                                                    <Button appearance="primary" size="lg"
                                                                        onClick={() => props.onClickButtonDeleteFile(file.file_id)}
                                                                    >ДА</Button>
                                                                </Stack>
                                                            }>

                                                            <div>
                                                                <BootstrapTooltip title={`Удалить файл ${file.file_name}`} placement="top" arrow>
                                                                    <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                                        <DeleteOutlinedIcon />
                                                                    </IconButton>
                                                                </BootstrapTooltip>
                                                            </div>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        )}
                    </Dropzone>

                    <div className={css.fileFooter}>
                        * Перетащите файлы с расширением <b>".pdf"</b> в область таблицы или нажмите эту кнопку:

                        <Dropzone onDropAccepted={(files) => props.fileUploader(files, 'RPD')}>
                            {({ getRootProps }) => (
                                <Button size="sm" appearance="link" {...getRootProps()}>ВЫБРАТЬ ФАЙЛЫ</Button>
                            )}
                        </Dropzone>
                    </div>
                </div>
            }

            {props.navFilesActive === 2 &&
                <div className={css.filesContent}>
                    <div className={css.fileHead}>
                        <div>Имя файла</div>
                        <div style={{ textAlign: 'center' }}>Дата создания</div>
                        <div></div>
                    </div>

                    <Dropzone onDropAccepted={(files) => props.fileUploader(files, 'MO')}>
                        {({ getRootProps, isDragAccept, isDragActive }) => (
                            <div {...getRootProps({ className: isDragAccept ? `${css.fileBody} dropZone` : `${css.fileBody}`, onClick: event => event.stopPropagation() })}>
                                {isDragActive
                                    ? <div style={{ margin: "auto 0" }}>Перетащите сюда файлы с расширением <b>".pdf"</b></div>
                                    : !props.filesListMo.length
                                        ? <Empty image={emptyDoc} description="Данные отсутствуют" heightBox="250px" heightImg="200px" />
                                        : props.filesListMo.map((file: any) => {
                                            return (
                                                <div key={file.file_id} className={css.fileRow}>
                                                    <div style={{ margin: 'auto 0' }}>{file.file_name}</div>
                                                    <div style={{ margin: 'auto 0', textAlign: 'center' }}>{file.create_date_time}</div>
                                                    <div style={{ margin: "auto 0", display: "flex", gap: "5px" }}>
                                                        <a href={file.file_url} target="_blank" rel="noreferrer">
                                                            <BootstrapTooltip title={`Открыть файл ${file.file_name}`} placement="top" arrow>
                                                                <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                                    <FileDownloadOutlinedIcon />
                                                                </IconButton>
                                                            </BootstrapTooltip>
                                                        </a>

                                                        <Popover placement="bottom" trigger="click"
                                                            content={
                                                                <Stack spacing={1.5} style={{ padding: "10px" }}>
                                                                    <div style={{ fontSize: "15px", letterSpacing: "1px", fontWeight: "600" }}>Удалить этот файл?</div>

                                                                    <Button appearance="primary" size="lg"
                                                                        onClick={() => props.onClickButtonDeleteFile(file.file_id)}
                                                                    >ДА</Button>
                                                                </Stack>
                                                            }>

                                                            <div>
                                                                <BootstrapTooltip title={`Удалить файл ${file.file_name}`} placement="top" arrow>
                                                                    <IconButton size="small" sx={{ color: "#5763b3", m: "auto 0" }}>
                                                                        <DeleteOutlinedIcon />
                                                                    </IconButton>
                                                                </BootstrapTooltip>
                                                            </div>
                                                        </Popover>
                                                    </div>
                                                </div>
                                            )
                                        })
                                }
                            </div>
                        )}
                    </Dropzone>

                    <div className={css.fileFooter}>
                        * Перетащите файлы с расширением <b>".pdf"</b> в область таблицы или нажмите эту кнопку: 

                        <Dropzone onDropAccepted={(files) => props.fileUploader(files, 'MO')}>
                            {({ getRootProps }) => (
                                <Button size="sm" appearance="link" {...getRootProps()}>ВЫБРАТЬ ФАЙЛЫ</Button>
                            )}
                        </Dropzone>
                    </div>
                </div>
            }
        </div>
    )
}

export default Umkd